import {
  errorText,
  isApiSuccess,
  listFromPayload,
  pick,
} from "../Offices/officeHelpers";

export { errorText, isApiSuccess, pick };

export const EMPTY_USER_FORM = {
  name: "",
  email: "",
  password: "",
  address: "",
  phone_number: "",
  office: "",
  image: "",
};

export function userId(user) {
  const id = pick(user, ["id", "pk", "user_id", "inspection_user_id"]);
  return id == null || id === "" ? null : id;
}

export function officeLabel(office) {
  if (!office) return "this office";
  if (typeof office !== "object") return String(office);
  const address = pick(office, ["Address", "address"]);
  const area = pick(office, ["Area", "area"]);
  return [address, area].filter(Boolean).join(", ") || "this office";
}

export function userImageUrl(user) {
  return (
    pick(user, ["image", "Image", "photo", "profile_image", "picture"]) || ""
  );
}

export function usersFromPayload(payload) {
  if (Array.isArray(payload?.users)) return payload.users;
  if (Array.isArray(payload?.inspection_users)) return payload.inspection_users;
  if (Array.isArray(payload?.data?.users)) return payload.data.users;
  if (Array.isArray(payload?.data?.inspection_users)) {
    return payload.data.inspection_users;
  }
  return listFromPayload(payload);
}

export function toUserForm(user, officeId) {
  return {
    name: String(pick(user, ["name", "Name", "full_name"], "")),
    email: String(pick(user, ["email", "Email"], "")),
    password: "",
    address: String(pick(user, ["address", "Address"], "")),
    phone_number: String(
      pick(user, ["phone_number", "phone", "mobile", "Phone"], "")
    ),
    office: String(
      pick(user, ["office", "office_id", "Office"], officeId || "")
    ),
    image: userImageUrl(user),
  };
}

export function matchesUserSearch(user, query) {
  if (!query) return true;
  const q = query.trim().toLowerCase();
  if (!q) return true;
  return [
    pick(user, ["name", "Name", "full_name"]),
    pick(user, ["email", "Email"]),
    pick(user, ["phone_number", "phone", "mobile"]),
    pick(user, ["address", "Address"]),
  ]
    .join(" ")
    .toLowerCase()
    .includes(q);
}

export function isValidEmail(value) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value).trim());
}

export function fieldErrorsFromUserApi(json) {
  if (!json || typeof json !== "object") return {};
  const next = {};
  const map = {
    name: "name",
    Name: "name",
    email: "email",
    Email: "email",
    password: "password",
    address: "address",
    Address: "address",
    image: "image",
    phone_number: "phone_number",
    phone: "phone_number",
    office: "office",
  };
  Object.keys(map).forEach((key) => {
    const value = json[key];
    if (!value) return;
    const text = Array.isArray(value) ? value[0] : String(value);
    if (text) next[map[key]] = text;
  });
  return next;
}

export function userFormData(form, imageFile, { includePassword } = {}) {
  const data = new FormData();
  data.append("name", String(form.name).trim());
  data.append("email", String(form.email).trim());
  const address = String(form.address || "").trim();
  const phone = String(form.phone_number || "").trim();
  if (address) data.append("address", address);
  if (phone) data.append("phone_number", phone);
  data.append("office", String(form.office).trim());
  if (includePassword && String(form.password).trim()) {
    data.append("password", String(form.password));
  }
  if (imageFile) {
    data.append("image", imageFile);
  }
  return data;
}
